/* Start the existing native ratings app when a script-delay optimizer holds its loader. */
(() => {
  function loadNativeRatings() {
    if (!document.querySelector('.individual_product [data-bv-show="rating_summary"]')) return;
    if (window.$BV || window.__echelonNativeRatingsRequested) return;
    const scripts = [...document.scripts];
    const isProvider = url => {
      try {
        const parsed = new URL(url, location.href);
        return parsed.protocol === 'https:' &&
          ((parsed.hostname === 'cdn.shopify.com' && parsed.pathname.includes('/apps.bazaarvoice.com/deployments/')) ||
            (parsed.hostname === 'apps.bazaarvoice.com' && parsed.pathname.startsWith('/deployments/'))) &&
          parsed.pathname.endsWith('/bv.js');
      } catch (_) {
        return false;
      }
    };
    if (scripts.some(script => script.src && isProvider(script.src) && !/flspdscript|lazy|delay/i.test(script.type))) return;

    // Reuse Shopify's configured provider URL; never evaluate the delayed app bundle.
    let providerURL;
    for (const script of scripts) {
      if (!script.textContent.includes('apps.bazaarvoice.com')) continue;
      const match = script.textContent.match(/var urls\s*=\s*(\[[\s\S]*?\]);/);
      if (!match) continue;
      try {
        const urls = JSON.parse(match[1]);
        if (Array.isArray(urls)) providerURL = urls.find(url => typeof url === 'string' && isProvider(url));
      } catch (_) {
        continue;
      }
      if (providerURL) break;
    }
    if (!providerURL) return;
    const nativeScript = document.createElement('script');
    nativeScript.src = providerURL;
    nativeScript.async = true;
    nativeScript.dataset.echelonNativeRatings = 'true';
    window.__echelonNativeRatingsRequested = true;
    nativeScript.addEventListener('error', () => {
      console.warn('The native product ratings provider could not be loaded.');
    }, { once: true });
    document.head.append(nativeScript);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadNativeRatings, { once: true });
  } else {
    loadNativeRatings();
  }
})();
